<h2 mat-dialog-title>Confirmation Dialog</h2>
<mat-dialog-content>
  You have decided to delete the following attributes: <strong>{{deletedAttributes.join( ', ' )}}</strong>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Confirm</button>
</mat-dialog-actions>

